import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withAuth0 } from "@auth0/auth0-react";
import { withRouter } from "react-router";
import apiUrls from "../../urls";

import UserUnavailable from "../UserUnavailable";

// Redux imports
import { onAuthorization } from "../../actions/userActions";

// style
import "./LoginScreen.scss";

function mapStateToProps(state, ownProps) {
    const { api, settings: { firstTimeLogin }, user, userState } = state;
    const { userState: { loading: userLoading, loaded: userLoaded, userUnavailable } } = state;

    return {
        api,
        firstTimeLogin,
        user,
        userLoading,
        userLoaded,
        userState,
        userUnavailable,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onAuthorized() {
            dispatch(onAuthorization());
        }
    };
}

class LoginScreen extends Component {
    componentDidMount() {
        this.componentMightAuth(this.props);

        this.goToLogin = () => {
            this.props.auth0.loginWithRedirect();
        };
    }

    componentDidUpdate(prevProps) {
        this.componentMightAuth(prevProps);
    }

    /**
     * This logic can fire on mount or on update
     * @return {void}
     */
    componentMightAuth(prevProps) {
        const isAuthenticated = this.props.auth0.isAuthenticated;
        const loaded = prevProps.userLoaded || this.props.userLoaded;
        const loading = prevProps.userLoading || this.props.userLoading;
        const unavailable = this.props.userUnavailable;

        const shouldAuthorize = isAuthenticated && !loading && !loaded && !unavailable;

        if (shouldAuthorize) {
            this.props.onAuthorized();

            return;
        }

        let pathname;

        if (unavailable) {
            pathname = "/user-unavailable";
        } else if (isAuthenticated && !prevProps.userLoaded && this.props.userLoaded) {
            pathname = this.props.firstTimeLogin ? "/welcome" : "/input-time";
        }

        if (pathname) {
            this.props.router.replace({ pathname });
        }
    }

    render() {
        const { isAuthenticated, isLoading, loginWithRedirect } = this.props.auth0;

        const authLoading = !isAuthenticated && isLoading;
        const userLoading = this.props.userLoading;
        const loadingSession = authLoading || userLoading;

        let label = "Log in";

        if (isAuthenticated && !loadingSession) {
            label = `Authenticated ${this.props.auth0.user.name}`;
        } else if (loadingSession) {
            label = isLoading ? `Authenticating with auth0...` : `Loading user from server...`;
        }

        return (
            <div className="loginScreen text-center">
                <div className="loginContent">
                    <img src={require("./assets/loginLogo.png")}
                        alt="Mentor Graphics Time Tracker"
                    />
                    {this.props.userUnavailable && <UserUnavailable />}
                    <button
                        className="btn-submit"
                        disabled={isAuthenticated || loadingSession}
                        onClick={this.goToLogin}
                    >
                        {label}
                    </button>
                </div>
            </div>
        );
    }
}

LoginScreen.propTypes = {
    auth0: PropTypes.shape({
        isAuthenticated: PropTypes.bool,
        isLoading: PropTypes.bool,
        loginWithRedirect: PropTypes.func.isRequired,
        user: PropTypes.object,
    }),
    router: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired
};

const DecoratedLogin = withRouter(withAuth0(LoginScreen));

export default connect(mapStateToProps, mapDispatchToProps)(DecoratedLogin);



// WEBPACK FOOTER //
// ./app/components/LoginScreen/index.jsx